// import * as THREE from "three";
// import { Viewer, ImagePanorama, Infospot } from "panolens";
import { useEffect, useRef, useState } from 'react';
import '../assets/css/location.css';
import locationImg from '../assets/images/Elysium_Tower/Location/location.jpg';

function LocationElysiumTower() {
    const containerRef = useRef(null);
    const modalRef = useRef(null);

    useEffect(() => {
        // Hide all paths with stroke #ffff00 initially
        document.querySelectorAll('.animated-path').forEach(path => {
            path.style.strokeDasharray = path.getTotalLength();
            path.style.strokeDashoffset = path.getTotalLength();
            path.style.transition = 'stroke-dashoffset 3s ease-in-out';
        });
    }, []);
    useEffect(() => {
        // Center the view on mobile
        if (window.innerWidth <= 767 && containerRef.current) {
            containerRef.current.scrollLeft = containerRef.current.scrollWidth / 3;
        }
    }, []);
    const handleIconClick = (iconName) => {
        const pathId = `${iconName}_path`;
        const pathElement = document.getElementById(pathId);
        console.log("djhf", pathId, pathElement);
        if (pathElement) {
            // Reset all paths before animating the selected one
            document.querySelectorAll('.animated-path').forEach(path => {
                path.style.strokeDashoffset = path.getTotalLength();
            });

            // Animate the selected path
            // Animate the selected path
            requestAnimationFrame(() => {
                pathElement.style.strokeDashoffset = "0";
            });
            // pathElement.style.strokeDashoffset = '0';
            console.log("sfhdhfs", pathId, pathElement)
        }
    };

    // diatance details
    const [distanceDetails, setDistanceDetails] = useState({});
    const [distanceDetailsModel, setDistanceDetailsModel] = useState(false);

    const handleShowDistance = (details) => {
        setDistanceDetails(details);
        setDistanceDetailsModel(true);
    }

    const checkClickOutside = (e) => {
        if (distanceDetailsModel && modalRef.current && !modalRef.current.contains(e.traget)) {
            setDistanceDetailsModel(false);
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', checkClickOutside);
        return () => document.removeEventListener('mousedown', checkClickOutside);
    }, [distanceDetailsModel])

    return (
        <div className="w-100">
            <div className="location_main_container elysium_tower" ref={containerRef}>
                <img src={locationImg} className="location_image_bg" alt="location_image_bg" />
            </div>
        </div>
    );
}

export default LocationElysiumTower;
